import React from "react";
import { useParams, useNavigate } from 'react-router-dom';

import NaviBar from "../../../../Component/Eng_Nav/Navbar";
import Container from "react-bootstrap/Container";
import Badge from "react-bootstrap/Badge";
import { Alert, Button } from "react-bootstrap";

import './Project_detail.css'
import data from '../data.json';

function Project_detail() {
    const { itemId } = useParams();
    const navigate = useNavigate();
    const project = data.data.find((item) => item.id === itemId) || {};

    // 이전 페이지로 이동하는 함수
    const goBack = () => {
        navigate(-1);
    };

    return (
        <>
            <NaviBar></NaviBar>
            <div className={'project-detail-bg'}>
                <Container className={'like-a-card'}>
                    <h2>{project.title}</h2>
                    <p><i>{project.type}</i></p>
                    <hr></hr>
                    <h5 id="subtitle">{project.subtitle}</h5>
                    <hr></hr>
                    <Badge className={'pj-detail-badge'}>{project.keyword1}</Badge>
                    <Badge className={'pj-detail-badge'}>{project.keyword2}</Badge>
                    <Button id = {'pj-back'} onClick={goBack}> ← Go to back</Button>
                    <img id="pj-img" src={project.src} alt="project"></img>
                    <hr></hr>
                    <h5 id="pj-detail-desc-top">
                        <h6 className="point">"</h6>
                        {project.description}
                        <h6 className="point">"</h6>
                    </h5>
                    <br />
                    <p id="pj-detail-desc">
                        <p>{project.detail_total}</p>
                        <p>{project.detail_sub}</p>
                    </p>
                    <hr></hr>
                    <a id="project_link" href={project.link} style={{textAlign:"right"}}> 🚶🏻‍♀️ Move to link about project</a>
                </Container>
            </div>
        </>
    )
}

export default Project_detail;
